import type { RouteObject } from 'react-router-dom';
import { NewCustomerForm } from '../components/NewCustomerForm/NewCustomerForm';

export const customersRoutes: RouteObject[] = [
    {
        path: 'customerers',
        children: [
            {
                path: 'new',
                element: <NewCustomerForm onSubmit={() => {}} />,
            },
        ],
    },
];
